import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import { ViError } from '@vi-iot/client';
import { TutorialsData, TutorialType } from './tutorials.model';

export namespace TutorialsActions {
  export const fetchTutorials = createActionGroup({
    source: '[TUTORIALS] Fetch tutorials',
    events: {
      attempt: emptyProps(),
      success: props<{ tutorials: TutorialsData[] }>(),
      error: props<{
        error: ViError;
      }>(),
    },
  });

  export const saveTutorials = createActionGroup({
    source: '[TUTORIALS] Save tutorials',
    events: {
      attempt: props<{ tutorials: TutorialsData[] }>(),
      success: emptyProps(),
      error: props<{
        error: ViError;
      }>(),
    },
  });

  export const markAsPresented = createAction(
    '[TUTORIALS] Mark as presented',
    props<{
      tutorialType: TutorialType;
    }>()
  );

  export const resetTutorial = createAction(
    '[TUTORIALS] Reset tutorial',
    props<{
      tutorialType: TutorialType;
    }>()
  );
}
